/**
 * Staggered scroll reveal — direction C, phase 1.
 *
 * Deliberately NOT a custom element: a custom element needs a tag in the markup, and phase 1
 * touches no section, snippet or template. Phase 2 replaces this with markup hooks.
 *
 * Visibility is decided by the IntersectionObserver's first callback for each element, not by
 * measuring position at load. Scroll restoration and anchor jumps are not guaranteed to finish
 * before DOMContentLoaded, so a getBoundingClientRect() check taken then can be wrong by the
 * time the browser settles. Deferring the decision to the observer's first report — which fires
 * after any such jump — makes the reveal immune to that race, and still buys the same three
 * guarantees: no flash of hidden content (an element already on screen is marked revealed on
 * its very first callback and is never hidden), no LCP regression (anything visible on load is
 * revealed immediately, untouched by the transition), and no blank store if this file fails to
 * load (nothing is ever hidden except by this script itself).
 */
(function () {
  'use strict';

  var STAGGER_MS = 60;
  var MAX_STEPS = 6;
  var SELECTOR = '.grid__item';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function isExcluded(el) {
    // jQuery owns the transforms inside owl carousels; adding transitions fights it.
    if (el.closest('.owl-carousel')) return true;
    if (el.classList.contains('slider__slide')) return true;
    // Footer blocks share .grid__item. Revealing the footer is noise, not polish.
    if (el.classList.contains('footer-block')) return true;
    return false;
  }

  function init() {
    var seen = new WeakSet();

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          var isFirstCallback = !seen.has(el);
          if (isFirstCallback) seen.add(el);

          if (entry.isIntersecting) {
            // Already on screen — reveal it directly, it was never hidden.
            el.classList.add('sr-in');
            observer.unobserve(el);
            return;
          }

          if (isFirstCallback) {
            // Genuinely offscreen on this first report — safe to hide and animate in later.
            el.classList.add('sr');
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (isExcluded(el)) return;

      var siblings = Array.prototype.slice.call(el.parentElement.children);
      var index = siblings.indexOf(el);
      var step = Math.min(index, MAX_STEPS - 1);

      el.style.transitionDelay = step * STAGGER_MS + 'ms';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
